webpackJsonp([8503015651353310000],{

/***/ "./data/templates.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var config = __webpack_require__("./data/config.js");
	var root =  true ? config.pathPrefix ? config.pathPrefix + '/' : '/' : '/';
	
	module.exports = [{
	  id: 'post',
	  prefix: '/updates',
	  hero: {
	    type: 'post',
	    figure: true,
	    headline: {
	      level: 2,
	      button: {
	        type: 'category link',
	        prefix: '/categories/'
	      }
	    }
	  },
	  content: {
	    type: 'post'
	  },
	  cta: {
	    type: 'fluid',
	    figure: 'container'
	  },
	  heel: {
	    type: 'fluid',
	    figure: 'container'
	  },
	  affixed: {
	    type: 'fluid',
	    figure: 'inline bottom right'
	  }
	}, {
	  id: 'category',
	  type: 'updates',
	  prefix: '/categories/',
	  hero: {
	    figure: true,
	    headline: {
	      level: 1
	    }
	  },
	  listing: {
	    type: 'posts',
	    figure: 'posts',
	    button: {
	      type: 'primary link',
	      label: 'View All Updates'
	    },
	    prefix: '/updates'
	  },
	  cta: {
	    type: 'centered'
	  },
	  heel: {
	    type: 'fluid'
	  }
	}, {
	  id: 'tag',
	  type: 'updates',
	  prefix: '/tags/',
	  hero: {
	    figure: true,
	    headline: {
	      level: 1
	    }
	  },
	  listing: {
	    type: 'posts',
	    figure: 'posts',
	    button: {
	      type: 'primary link',
	      label: 'View All Updates'
	    },
	    prefix: '/updates'
	  },
	  cta: {
	    type: 'centered'
	  },
	  heel: {
	    type: 'fluid'
	  }
	}];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/dvz/Projects/gatsby-castmaker/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/dvz/Projects/gatsby-castmaker/node_modules/babel-plugin-lodash/lib/index.js\",\"/Users/dvz/Projects/gatsby-castmaker/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/dvz/Projects/gatsby-castmaker/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/dvz/Projects/gatsby-castmaker/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/dvz/Projects/gatsby-castmaker/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/dvz/Projects/gatsby-castmaker/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/category.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _capitalize2 = __webpack_require__("./node_modules/lodash/capitalize.js");
	
	var _capitalize3 = _interopRequireDefault(_capitalize2);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _hero = __webpack_require__("./src/containers/hero/index.jsx");
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _listing = __webpack_require__("./src/containers/listing/index.jsx");
	
	var _listing2 = _interopRequireDefault(_listing);
	
	var _cta = __webpack_require__("./src/containers/cta/index.jsx");
	
	var _cta2 = _interopRequireDefault(_cta);
	
	var _heel = __webpack_require__("./src/containers/heel/index.jsx");
	
	var _heel2 = _interopRequireDefault(_heel);
	
	var _mailchimp = __webpack_require__("./src/components/mailchimp/index.jsx");
	
	var _mailchimp2 = _interopRequireDefault(_mailchimp);
	
	var _social_links = __webpack_require__("./src/components/social_links/index.jsx");
	
	var _social_links2 = _interopRequireDefault(_social_links);
	
	var _counter = __webpack_require__("./src/components/counter/index.jsx");
	
	var _counter2 = _interopRequireDefault(_counter);
	
	var _config = __webpack_require__("./data/config.js");
	
	var _config2 = _interopRequireDefault(_config);
	
	var _templates = __webpack_require__("./data/templates.js");
	
	var _templates2 = _interopRequireDefault(_templates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CategoryTemplate = function (_React$Component) {
	  _inherits(CategoryTemplate, _React$Component);
	
	  function CategoryTemplate() {
	    _classCallCheck(this, CategoryTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  CategoryTemplate.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        pathContext = _props.pathContext,
	        location = _props.location;
	
	    var template = _templates2.default.filter(function (template) {
	      return template.id === 'category';
	    })[0];
	    var category = pathContext.category;
	    var posts = data.allMarkdownRemark.edges;
	
	    var title = void 0;
	    if (template.hero.headline.title) {
	      title = template.hero.headline.title;
	    } else {
	      title = category;
	    }
	
	    var button = void 0;
	    if (template.listing.button) {
	      button = {
	        type: template.listing.button.type,
	        label: template.listing.button.label
	      };
	    } else {
	      button = false;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: template.id + ' template' },
	      _react2.default.createElement(_reactHelmet2.default, { title: (0, _capitalize3.default)(template.type) + ' in category "' + category + '" | ' + _config2.default.siteTitle }),
	      _react2.default.createElement(
	        'div',
	        { className: template.id + ' page' },
	        _react2.default.createElement(_hero2.default, { figure: template.hero.figure,
	          level: template.hero.headline.level,
	          title: title }),
	        _react2.default.createElement(_listing2.default, { type: template.listing.type,
	          figure: template.listing.figure,
	          prefix: template.listing.prefix,
	          button: button,
	          list: posts }),
	        _react2.default.createElement(
	          _cta2.default,
	          { type: template.cta.type },
	          _react2.default.createElement(_mailchimp2.default, { figure: true,
	            title: _config2.default.subscribeTitle,
	            caption: _config2.default.subscribeCaption,
	            action: _config2.default.mailchimpAction,
	            disclaimer: _config2.default.subscribeDisclaimer }),
	          _react2.default.createElement(_social_links2.default, { links: _config2.default.userLinks })
	        ),
	        _react2.default.createElement(
	          _heel2.default,
	          { type: template.heel.type },
	          _react2.default.createElement(_counter2.default, { type: template.heel.type,
	            title: _config2.default.countdownTitle,
	            date: _config2.default.countdownDate,
	            message: _config2.default.counterMessage })
	        )
	      )
	    );
	  };
	
	  return CategoryTemplate;
	}(_react2.default.Component);
	
	/* eslint no-undef: "off"*/
	
	
	exports.default = CategoryTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-category-jsx-d0b7c9d995f0defb2625.js